import { Form } from "antd";
import dayjs from "dayjs";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";

const OfficerReportAdministrativeInfo = ({ report = {}, startingPoint = "" }) => {
  return (
    <FieldSecurityProvider
      entity="OffenseDetails"
      startingPoint={startingPoint}
    >
      <Form
        layout="vertical"
        initialValues={{
          officerReportID: report.officerReportID || "",
          dateTimeEntered:
            report.dateAdded && report.timeAdded
              ? dayjs(`${report.dateAdded} ${report.timeAdded}`, "MM/DD/YYYY HH:mm")
              : null,
          user: report.user || "",
        }}
      >
        <StyledGridRow gutter={16} justify={'start'}>
          <StyledGridCol span={4}>
            <SecureFormItem
              fieldName="officerReportID"
              formItemProps={{ name: "officerReportID", label: "ID" }}
            >
              <TextField />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <SecureFormItem
              fieldName="dateTimeEntered"
              formItemProps={{ name: "dateTimeEntered", label: "Date & Time Added" }}
            >
              <CommonDatePicker format="MM/DD/YYYY HH:mm" />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <SecureFormItem
              fieldName="user"
              formItemProps={{ name: "user", label: "User" }}
            >
              <TextField />
            </SecureFormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </FieldSecurityProvider>
  );
};

export default OfficerReportAdministrativeInfo;
